<template>
    <div>
        <BasicCard v-if="loading" v-bind:title="`Caricamento in corso`" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        <div v-else>
            <v-hover><v-chip 
                slot-scope="{ hover }"
                :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                @click="close" absolute top left>
                <v-icon>keyboard_arrow_left</v-icon>back</v-chip></v-hover>

            <BasicCard>
                <template v-slot:title>
                    <span v-if="preview">Dettagli</span>
                    <span v-else-if="procedure_new">Nuova procedura</span>
                    <span v-else>Modifica la procedura</span>
                </template>
                <template v-slot:action>
                    <v-btn v-if="!preview && !procedure_new" class="pa-2" text @click="restore"><v-icon>restore</v-icon>annulla modifiche</v-btn>
                </template>
                <v-form :readonly="preview" v-model="validityRegistry" ref="procedureRegistry">
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="4"> 
                            <v-text-field dense outlined
                                label="nome*"
                                v-model="c_data.name"
                                :rules="[rules.mandatory]"
                            ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-2">
                            <v-autocomplete dense outlined
                                    
                                :items=Object.keys(families)
                                v-model="c_data.family"
                                label="famiglia*"
                                :rules="[rules.mandatory]">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="4" class="pl-2" v-if="c_data.family">
                                <v-autocomplete dense outlined
                                    class="d-flex flex-sm-shrink-1 flex-sm-grow-0"
                                    :items="Object.keys(families[c_data.family].report)"
                                    v-model="c_data.op_type"
                                    label="tipo operazione*"
                                    :rules="[rules.mandatory]">
                                    <template v-slot:item="{ item }">{{types[item].name}}</template>
                                    <template v-slot:selection="{ item }">{{types[item].name}}</template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
                            <v-col cols="4" >
                                <CalendarField
                                    v-model="c_data.date" 
                                    label="data di emissione*"
                                    :rules="[rules.mandatory]">
                                </CalendarField>
                            </v-col>
                            <v-col cols="4" class="pl-2">
                                <CalendarField
                                    v-model="c_data.expiry" 
                                    label="data di scadenza*"
                                    :rules="[rules.mandatory]">
                                </CalendarField>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-textarea dense outlined
                                    label="note"
                                    v-model="c_data.note"
                                    rows="3"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="8">
                                <span v-if="c_data.file_ref">
                                    <v-progress-linear
                                        v-if="uploading"
                                        color="primary"
                                        indeterminate
                                        rounded
                                        height="6"
                                    ></v-progress-linear>
                                    <a v-if="c_data.file_ref" :href="getCertPath()+''+c_data.file_ref" target="_blank">
                                        <v-icon>get_app</v-icon>
                                        <span v-if="c_data.file_name">{{c_data.file_name}}</span>
                                        <span v-else> procedura</span>
                                    </a>
                                </span>
                            </v-col>
                            <v-col cols="4" class="pl-4">
                                <VueUploadComponent
                                    ref="upload"
                                    v-model="files"
                                    input-id="file1"
                                    class="btn"
                                    accept="application/pdf"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    >
                                    <v-btn :disabled="$store.state.offline" v-if="!preview" elevation-2 color="primary">
                                        <span class="pr-1" v-if="c_data.file_ref">aggiorna</span><span class="pr-1" v-else>carica</span> procedura
                                    </v-btn>
                                </VueUploadComponent>
                            </v-col>
                            <v-col cols="12">
                                <v-alert type="error" :value="failed">
                                    errore durante il caricamento del file
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <div class="pa-4">
                    <v-alert
                        v-if="save_error"
                        dense
                        type="warning"
                        >
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold">Salvataggio fallito</div>
                            <div>Riprovare oppure segnalare il problema all'amministratore di sistema.</div>
                        </div>
                    </v-alert>
                </div>
            
            </BasicCard>
            <div v-if="!preview" class="d-flex justify-center my-4">
                <v-btn color="primary" :disabled="!valid" @click="saveProcedure">Salva</v-btn>
                <v-btn color="primary" class="ml-2" :disabled="!valid" @click="saveProcedure(true)">Salva e attiva</v-btn>
                <v-btn class="ml-2" text @click="close">Annulla</v-btn>
            </div>
        </div>
    </div>
</template>
<script>

// import _ from 'lodash'
// import {Master} from '../../utils/objectSchema.js'
import {i_families, report_type} from "../../utils/common.js"
import {getModel} from "../../utils/model"
import {f_rules, getCertificatePath} from "../../utils/commonUtils"
import BasicCard from '../../components/utils/Basic_card'
import VueUploadComponent from "vue-upload-component";


export default {
    props: {
        'p_id': {
            type: String,
            required: false,
            default: null
        },
        'clone': {
            type: Boolean,
            required: false,
            default: false
        },
        'preview': {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        BasicCard, VueUploadComponent
    },

    data(){
        return{
            o_data: {},
            c_data: {},
            families: i_families,
            rules: f_rules,
            types: report_type,
            validityRegistry: true,
            loading: false,
            procedure_new: true,
            files: [],
            uploading: false,
            failed: false,
            save_error: false
        }
    },
    async mounted() {
        this.loading = true
        this.o_data = {}
        this.procedure_new = true
        if (this.p_id) {
            let procedure = await this.$store.state.$pouch.get('registry', this.p_id)
            this.o_data = procedure
            this.c_data = _.cloneDeep(this.o_data)
        } else {
            this.c_data = this.initObjectData({})   
        }
        this.loading = false
        //this.$refs.procedureRegistry.resetValidation()
    },
    methods: {
        getCertPath() {
            return getCertificatePath()
        },
        initObjectData(data) {
            console.log("$$ init data")
            let Procedure = getModel('Procedure')
            let procedure = Procedure({
                created_by: this.$store.state.user._id,
            })
            return procedure
        },
        async saveProcedure(activated = false) {
            // if(this.files.length > 0){
            //     await this.inputFile()
            // }
            this.save_error = false
            try {
                this.c_data.active = activated
                this.c_data.updated_by = this.$store.state.user._id
                this.c_data.updated = (new Date()).getTime()
                let res = await this.$store.state.$pouch.put('registry', this.c_data)
                if (res.ok) {
                    this.c_data._rev = res.rev
                    console.log("Update procedure " , res)
                    this.close()
                }
            } catch (error) {
                this.save_error = true
                console.log('error', error)
            }
            
        },
        async restore() {
            this.c_data = _.cloneDeep(this.o_data);
        },
        close() {
            this.$router.push({path: '/admin/procedure/'})
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-pdf file
                if (!/\.(pdf)$/i.test(newFile.name)) {
                console.log("filtered non pdf file")
                return prevent()
                }
            }
        },
        async inputFile(){
            // this.$refs.upload.active = true
            this.uploading = true;
            this.failed = false;
            //console.log("file selected", this.files[0].file)
            let uuidv1 = require('uuid/v1')
            let name = uuidv1()+".pdf"
            let form = new window.FormData()
            form.append('file', this.files[0].file)
            let res = await this.axios.post(
                "/mastercal/procedures/files", form, 
                {
                    headers: {"Content-Type": "multipart/formdata"},
                    params: {file_name: name}
                }).catch((error) => {
                    if(error){
                        console.log("error status", error);
                        this.failed = true
                        this.uploading = false
                    }
                })
            console.log("result axios", res)
            if(res.status == 200){
                console.log("confirmed update")
                this.c_data.file_ref = res.data
                this.c_data.file_name = this.files[0].file.name
                this.uploading = false
            }

        }
    },
    computed: {
        valid() {
            if(this.validityRegistry){
                return this.validityRegistry && this.fileSelected
            }
            return false
        },
        fileSelected(){
            if(this.c_data && this.c_data.file_ref){
                return true
            }
            return false
        }
    }
}
</script>

